/* @generated from adl module ferovinum.app.annotations */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';

export interface DbAudit {
  auditRows: boolean;
  auditQueryText: boolean;
}

export function makeDbAudit(
  input: {
    auditRows: boolean,
    auditQueryText: boolean,
  }
): DbAudit {
  return {
    auditRows: input.auditRows,
    auditQueryText: input.auditQueryText,
  };
}

const DbAudit_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.annotations","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"auditRows","default":{"kind":"nothing"},"name":"auditRows","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"auditQueryText","default":{"kind":"nothing"},"name":"auditQueryText","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"DbAudit","version":{"kind":"nothing"}}};

export const snDbAudit: ADL.ScopedName = {moduleName:"ferovinum.app.annotations", name:"DbAudit"};

export function texprDbAudit(): ADL.ATypeExpr<DbAudit> {
  return {value : {typeRef : {kind: "reference", value : snDbAudit}, parameters : []}};
}

export interface SensitiveFieldReplacement_Hash {
  kind: 'hash';
}
export interface SensitiveFieldReplacement_Words {
  kind: 'words';
  value: WordParams;
}
export interface SensitiveFieldReplacement_Email {
  kind: 'email';
}
export interface SensitiveFieldReplacement_BigDecimal {
  kind: 'bigDecimal';
  value: MinMax<common.BigDecimal>;
}
export interface SensitiveFieldReplacement_Faker {
  kind: 'faker';
  value: FakerParams;
}
export interface SensitiveFieldReplacement_Custom {
  kind: 'custom';
}

/**
 * Defines how a field of a DbTable should be obfuscated for development data.
 */
export type SensitiveFieldReplacement = SensitiveFieldReplacement_Hash | SensitiveFieldReplacement_Words | SensitiveFieldReplacement_Email | SensitiveFieldReplacement_BigDecimal | SensitiveFieldReplacement_Faker | SensitiveFieldReplacement_Custom;

export interface SensitiveFieldReplacementOpts {
  /**
   * The field is replaced with the hash of its contents
   */
  hash: null;
  /**
   * Replace the contents of the field with random words
   */
  words: WordParams;
  /**
   * Replace the field with a fake email address
   */
  email: null;
  /**
   * Replace the field with a BigDecimal value between the provided min and
   * max values
   */
  bigDecimal: MinMax<common.BigDecimal>;
  /**
   * Use custom logic from fakerjs by using a pattern
   */
  faker: FakerParams;
  /**
   * Use custom logic to replace the field 
   * Custom logic is implemented in client/apps/db-dump-obfuscation/src/custom-obfuscation.ts
   */
  custom: null;
}

export function makeSensitiveFieldReplacement<K extends keyof SensitiveFieldReplacementOpts>(kind: K, value: SensitiveFieldReplacementOpts[K]) { return {kind, value}; }

const SensitiveFieldReplacement_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.annotations","decl":{"annotations":[{"value":"Defines how a field of a DbTable should be obfuscated for development data.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"The field is replaced with the hash of its contents\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"hash","default":{"kind":"nothing"},"name":"hash","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"value":"Replace the contents of the field with random words\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"words","default":{"kind":"just","value":{"numWords":1}},"name":"words","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.annotations","name":"WordParams"}},"parameters":[]}},{"annotations":[{"value":"Replace the field with a fake email address\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"value":"Replace the field with a BigDecimal value between the provided min and\nmax values\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"bigDecimal","default":{"kind":"nothing"},"name":"bigDecimal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.annotations","name":"MinMax"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[{"value":"Use custom logic from fakerjs by using a pattern\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"faker","default":{"kind":"nothing"},"name":"faker","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.annotations","name":"FakerParams"}},"parameters":[]}},{"annotations":[{"value":"Use custom logic to replace the field \nCustom logic is implemented in client/apps/db-dump-obfuscation/src/custom-obfuscation.ts\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"custom","default":{"kind":"nothing"},"name":"custom","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SensitiveFieldReplacement","version":{"kind":"nothing"}}};

export const snSensitiveFieldReplacement: ADL.ScopedName = {moduleName:"ferovinum.app.annotations", name:"SensitiveFieldReplacement"};

export function texprSensitiveFieldReplacement(): ADL.ATypeExpr<SensitiveFieldReplacement> {
  return {value : {typeRef : {kind: "reference", value : snSensitiveFieldReplacement}, parameters : []}};
}

export interface FakerParams {
  /**
   * Faker pattern
   * Eg: "{{person.firstName}} {{person.suffix}}" // Durgan, Noe MD
   */
  pattern: string;
  /**
   * Whether the faker parameter is deterministic or not
   */
  deterministic: boolean;
}

export function makeFakerParams(
  input: {
    pattern: string,
    deterministic: boolean,
  }
): FakerParams {
  return {
    pattern: input.pattern,
    deterministic: input.deterministic,
  };
}

const FakerParams_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.annotations","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"value":"Faker pattern\nEg: \"{{person.firstName}} {{person.suffix}}\" // Durgan, Noe MD\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"pattern","default":{"kind":"nothing"},"name":"pattern","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"value":"Whether the faker parameter is deterministic or not\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"deterministic","default":{"kind":"nothing"},"name":"deterministic","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"FakerParams","version":{"kind":"nothing"}}};

export const snFakerParams: ADL.ScopedName = {moduleName:"ferovinum.app.annotations", name:"FakerParams"};

export function texprFakerParams(): ADL.ATypeExpr<FakerParams> {
  return {value : {typeRef : {kind: "reference", value : snFakerParams}, parameters : []}};
}

export interface WordParams {
  numWords: number;
}

export function makeWordParams(
  input: {
    numWords: number,
  }
): WordParams {
  return {
    numWords: input.numWords,
  };
}

const WordParams_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.annotations","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"numWords","default":{"kind":"nothing"},"name":"numWords","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"WordParams","version":{"kind":"nothing"}}};

export const snWordParams: ADL.ScopedName = {moduleName:"ferovinum.app.annotations", name:"WordParams"};

export function texprWordParams(): ADL.ATypeExpr<WordParams> {
  return {value : {typeRef : {kind: "reference", value : snWordParams}, parameters : []}};
}

export interface MinMax<T> {
  min: T;
  max: T;
}

export function makeMinMax<T>(
  input: {
    min: T,
    max: T,
  }
): MinMax<T> {
  return {
    min: input.min,
    max: input.max,
  };
}

const MinMax_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.annotations","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":["T"],"fields":[{"annotations":[],"serializedName":"min","default":{"kind":"nothing"},"name":"min","typeExpr":{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}},{"annotations":[],"serializedName":"max","default":{"kind":"nothing"},"name":"max","typeExpr":{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}}]}},"name":"MinMax","version":{"kind":"nothing"}}};

export const snMinMax: ADL.ScopedName = {moduleName:"ferovinum.app.annotations", name:"MinMax"};

export function texprMinMax<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<MinMax<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "ferovinum.app.annotations",name : "MinMax"}}, parameters : [texprT.value]}};
}

/**
 * Annotation that defines that this top level field of a DbTable should be
 * obfuscated when preparing a PROD data dump for use in local development
 */
export type SensitiveField = SensitiveFieldReplacement;

const SensitiveField_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.annotations","decl":{"annotations":[{"value":"Annotation that defines that this top level field of a DbTable should be\nobfuscated when preparing a PROD data dump for use in local development\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.annotations","name":"SensitiveFieldReplacement"}},"parameters":[]}}},"name":"SensitiveField","version":{"kind":"nothing"}}};

export const snSensitiveField: ADL.ScopedName = {moduleName:"ferovinum.app.annotations", name:"SensitiveField"};

export function texprSensitiveField(): ADL.ATypeExpr<SensitiveField> {
  return {value : {typeRef : {kind: "reference", value : snSensitiveField}, parameters : []}};
}

/**
 * Field-level annotation for the analytics (SQLMesh) decoder: when this field
 * is unpacked from a JSONB column, CAST the leaf to this SQL type instead of
 * the default scalar mapping (e.g. a FixedRate used as DOUBLE math downstream).
 * Read by the deno source-model generator into the manifest's cast_policy;
 * inert for every other backend.
 */
export type DbCast = string;

const DbCast_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.annotations","decl":{"annotations":[{"value":"Field-level annotation for the analytics (SQLMesh) decoder: when this field\nis unpacked from a JSONB column, CAST the leaf to this SQL type instead of\nthe default scalar mapping (e.g. a FixedRate used as DOUBLE math downstream).\nRead by the deno source-model generator into the manifest's cast_policy;\ninert for every other backend.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"DbCast","version":{"kind":"nothing"}}};

export const snDbCast: ADL.ScopedName = {moduleName:"ferovinum.app.annotations", name:"DbCast"};

export function texprDbCast(): ADL.ATypeExpr<DbCast> {
  return {value : {typeRef : {kind: "reference", value : snDbCast}, parameters : []}};
}

/**
 * Field-level annotation for the analytics (SQLMesh) decoder: the wire data for
 * this field is dirty against its declared integer type (e.g. {"singles": 50.75}
 * against Word64), so ROUND before casting to this SQL type — DuckDB truncates
 * and Databricks hard-errors on a fractional string; ROUND makes both agree.
 * Read by the deno source-model generator into the manifest's cast_policy;
 * inert for every other backend.
 */
export type DbRoundCast = string;

const DbRoundCast_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.annotations","decl":{"annotations":[{"value":"Field-level annotation for the analytics (SQLMesh) decoder: the wire data for\nthis field is dirty against its declared integer type (e.g. {\"singles\": 50.75}\nagainst Word64), so ROUND before casting to this SQL type — DuckDB truncates\nand Databricks hard-errors on a fractional string; ROUND makes both agree.\nRead by the deno source-model generator into the manifest's cast_policy;\ninert for every other backend.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"DbRoundCast","version":{"kind":"nothing"}}};

export const snDbRoundCast: ADL.ScopedName = {moduleName:"ferovinum.app.annotations", name:"DbRoundCast"};

export function texprDbRoundCast(): ADL.ATypeExpr<DbRoundCast> {
  return {value : {typeRef : {kind: "reference", value : snDbRoundCast}, parameters : []}};
}

/**
 * Field-level annotation for the analytics (SQLMesh) decoder: carve this
 * column's (wide, typically PII-bearing) union payload OUT of the entity-grain
 * cleaned model into a 1:1 sibling at parent grain, named
 * <entity>__<value>_unpack (the value is the sibling stem, e.g.
 * "delivery_option"). The parent strips the column; the sibling carries the
 * discriminator + every branch payload. Read by the deno source-model
 * generator into the manifest's unpack_sibling map; inert for every other
 * backend.
 */
export type DbUnpackSibling = string;

const DbUnpackSibling_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.annotations","decl":{"annotations":[{"value":"Field-level annotation for the analytics (SQLMesh) decoder: carve this\ncolumn's (wide, typically PII-bearing) union payload OUT of the entity-grain\ncleaned model into a 1:1 sibling at parent grain, named\n<entity>__<value>_unpack (the value is the sibling stem, e.g.\n\"delivery_option\"). The parent strips the column; the sibling carries the\ndiscriminator + every branch payload. Read by the deno source-model\ngenerator into the manifest's unpack_sibling map; inert for every other\nbackend.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"DbUnpackSibling","version":{"kind":"nothing"}}};

export const snDbUnpackSibling: ADL.ScopedName = {moduleName:"ferovinum.app.annotations", name:"DbUnpackSibling"};

export function texprDbUnpackSibling(): ADL.ATypeExpr<DbUnpackSibling> {
  return {value : {typeRef : {kind: "reference", value : snDbUnpackSibling}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.annotations.DbAudit" : DbAudit_AST,
  "ferovinum.app.annotations.SensitiveFieldReplacement" : SensitiveFieldReplacement_AST,
  "ferovinum.app.annotations.FakerParams" : FakerParams_AST,
  "ferovinum.app.annotations.WordParams" : WordParams_AST,
  "ferovinum.app.annotations.MinMax" : MinMax_AST,
  "ferovinum.app.annotations.SensitiveField" : SensitiveField_AST,
  "ferovinum.app.annotations.DbCast" : DbCast_AST,
  "ferovinum.app.annotations.DbRoundCast" : DbRoundCast_AST,
  "ferovinum.app.annotations.DbUnpackSibling" : DbUnpackSibling_AST
};
